import { createReducer } from "@reduxjs/toolkit";
import { TYPES } from "../../common/constants";

const fetchPropertySuitesDone = (_, { payload }) => {
  return [...payload];
};

const saveSuiteDone = (suites, { payload }) => {
  return [...suites, payload];
};

const deleteUnitDone = (suites, { payload }) => {
  return suites.filter((s) => s.id !== payload);
};

const updateSuiteDone = (suites, { payload }) => {
  return suites.map((s) => {
    if (s.id === payload.id) {
      return payload;
    }
    return s;
  });
};

const fetchSuiteByIdDone = (suites, { payload }) => {
  return [...suites, payload];
};

const fetchSuiteNotesDone = (suites, { payload }) => {
  return suites.map((p) => {
    if (p.id === payload.id) {
      return {
        ...p,
        notes: payload.notes,
      };
    }
    return p;
  });
};

const fetchSuiteServiceRequestsDone = (suites, { payload }) => {
  return suites.map((p) => {
    if (p.id === payload.id) {
      return {
        ...p,
        service_requests: payload.serviceRequests,
      };
    }
    return p;
  });
};

const fetchSuiteDocumentsDone = (suites, { payload }) => {
  return suites.map((p) => {
    if (p.id === payload.id) {
      return {
        ...p,
        documents: payload.documents,
      };
    }
    return p;
  });
};

const saveAssetDone = (suites, { payload }) => {
  return suites.map((c) => {
    if (c.id === payload.id) {
      return {
        ...c,
        assets: [...c.assets, payload.asset],
      };
    }
    return c;
  });
};

const clearSuitesDone = () => {
  return initialState;
};

const initialState = [];

export default createReducer(initialState, {
  [TYPES.FETCH_PROPERTY_SUITES_DONE]: fetchPropertySuitesDone,
  [TYPES.SAVE_SUITE_DONE]: saveSuiteDone,
  [TYPES.DELETE_UNIT_DONE]: deleteUnitDone,
  [TYPES.UPDATE_SUITE_DONE]: updateSuiteDone,
  [TYPES.FETCH_SUITE_BY_ID_DONE]: fetchSuiteByIdDone,
  [TYPES.FETCH_SUITE_NOTES_DONE]: fetchSuiteNotesDone,
  [TYPES.FETCH_SUITE_DOCUMENTS_DONE]: fetchSuiteDocumentsDone,
  [TYPES.FETCH_SUITE_SERVICE_REQUESTS_DONE]: fetchSuiteServiceRequestsDone,
  [TYPES.SAVE_ASSET_DONE]: saveAssetDone,
  [TYPES.CLEAR_SUITES]: clearSuitesDone,
});
